angular.module('ikeweb.spike.measure').factory('measurementFormatterService', ['ikemath', 'unitService', '$filter',
    function(ikemath, unitService, $filter) {

        var INCHES_IN_FEET = 12;
        var NON_BREAKING_SPACE = String.fromCharCode(160);
        var Units = ikemath.Units;

        var Decimals = {
            DEFAULT: 2
        };
        Decimals[Units.METER] = 2;
        Decimals[Units.CENTIMETER] = 1;
        Decimals[Units.FEET] = 1;
        Decimals[Units.INCH] = 1;

        function getDecimals(unit) {
            return Decimals[unit] || Decimals.DEFAULT;
        }

        function formatNumber(number, unit) {
            return $filter('number')(number, getDecimals(unit))
                .replace(new RegExp(NON_BREAKING_SPACE, 'g'), ' ');
        }

        function getSuffix() {
            var unit = unitService.getUnit();
            return Units.DISPLAY[unit];
        }

        function getAreaSuffix() {
            var unit = unitService.getUnit();
            return Units.DISPLAY_AREA[unit];
        }

        function convert(value) {
            var unit = unitService.getUnit();
            return Units.convert(value, Units.METER, unit);
        }

        function convertArea(value) {
            var unit = unitService.getUnit();
            return Units.convertArea(value, Units.METER, unit);
        }

        function separateFeetAndInches(inches) {
            var remainingInches = inches % INCHES_IN_FEET;
            return {
                feet: (inches - remainingInches) / INCHES_IN_FEET,
                inches: remainingInches
            };
        }

        function formatFeetAndInches(meters) {
            var convertedInches = Math.round(Units.convert(meters, Units.INCH, Units.METER));
            var separated = separateFeetAndInches(convertedInches);

            var formatted = separated.feet + Units.DISPLAY[Units.FEET];
            return separated.inches !== 0 ?
                formatted + ' ' + separated.inches + Units.DISPLAY[Units.INCH] :
                formatted;
        }

        function formatDistance(meters, unit) {
            var convertedNumber = Units.convert(meters, unit, Units.METER);
            return formatNumber(convertedNumber, unit) + Units.DISPLAY[unit];
        }

        function format(meters) {
            var unit = unitService.getUnit();
            return unit === Units.FEET ?
                formatFeetAndInches(meters) :
                formatDistance(meters, unit);
        }

        function formatArea(meters) {
            var unit = unitService.getUnit();
            var convertedNumber = Units.convertArea(meters, unit, Units.METER);
            return formatNumber(convertedNumber, unit) + Units.DISPLAY_AREA[unit];
        }

        return {
            format: format,
            formatArea: formatArea,
            convert: convert,
            convertArea: convertArea,
            getSuffix: getSuffix,
            getAreaSuffix: getAreaSuffix
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/measure/measurement/measurement.formatter.service.js
// module id = 519
// module chunks = 0